(() => {
  if (window.__plpStickyFiltersInitialized) return;
  window.__plpStickyFiltersInitialized = true;

  // The sticky filter bars (`snippets/nosto-plp-filters.liquid`, `blocks/_filters.liquid`)
  // are positioned purely off `--plp-sticky-offset` via an inline
  // `top: var(--plp-sticky-offset, 96px)`, so this script only ever has to keep that one
  // custom property up to date — no per-element writes and no DOM queries per frame.
  //
  // The offset itself comes from the `header:position` event that `sections/header.liquid`
  // already dispatches from inside its own rAF, carrying the header geometry it has just
  // computed. Reusing that value avoids a second, chained forced layout on every scroll
  // frame, which is the collection-page-specific cost this file used to add.
  let appliedOffset = null;
  let receivedHeaderGeometry = false;

  const setStickyOffset = (value) => {
    const next = Math.max(0, Math.ceil(value));

    if (next === appliedOffset) return;

    appliedOffset = next;
    document.documentElement.style.setProperty('--plp-sticky-offset', `${next}px`);
  };

  // Fallback only: used before the first `header:position` event arrives, or if the header
  // script is absent from the page for any reason.
  const measureFromDom = () => {
    const header = document.getElementById('site-header');

    setStickyOffset(header ? header.getBoundingClientRect().bottom : 0);
  };

  const requestFallbackMeasure = () => {
    if (receivedHeaderGeometry) return;

    window.requestAnimationFrame(measureFromDom);
  };

  const init = () => {
    // Measured synchronously, as the previous implementation did: this is a one-off
    // read that has to land before first paint, and rAF is suspended in background
    // tabs, which would otherwise leave the bar on its CSS default.
    measureFromDom();
  };

  window.addEventListener('header:position', (event) => {
    const bottom = event.detail?.bottom;

    if (typeof bottom !== 'number' || !Number.isFinite(bottom)) {
      measureFromDom();
      return;
    }

    receivedHeaderGeometry = true;

    // Already inside the header's rAF callback, and this is a write-only operation,
    // so it can be applied straight away without deferring another frame.
    setStickyOffset(bottom);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('resize', requestFallbackMeasure, { passive: true });
  window.addEventListener('load', requestFallbackMeasure, { passive: true });
})();
